// extracted by mini-css-extract-plugin
export var externalLink = "_a7-0";
export var internalLinkLabel = "_a7-1";